
define('template!portalConversationTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="conversation">\n  ';
 if (!inline) { ;
__p += '\n  <div class="conversation__order">\n    ';
 if (supplierCode) { ;
__p += '<span class="orders-row__code">' +
__e( supplierCode ) +
'</span>';
 } ;
__p += '\n    <span class="orders-row__poi">' +
__e( purchaseOrderId ) +
'</span>\n    <span class="orders-row__muted">' +
__e( productCode ) +
' ' +
__e( productName ) +
'</span>\n  </div>\n  ';
 } else { ;
__p += '\n  <div class="conversation__title">' +
((__t = ( _.i18n('portalMessages.inlineTitle', null, 'Messages with the supplier') )) == null ? '' : __t) +
'</div>\n  ';
 } ;
__p += '\n\n  <div class="conversation__thread js-thread"></div>\n\n  <textarea class="form-control conversation__draft js-draft" rows="4" maxlength="' +
((__t = ( maxLength )) == null ? '' : __t) +
'"\n            placeholder="' +
((__t = ( _.i18n('portalMessages.placeholder', null, 'Answer the supplier… (Ctrl+Enter to send)') )) == null ? '' : __t) +
'"></textarea>\n\n  <div class="error-message js-error"></div>\n\n  <div class="popup-footer">\n    ';
 if (!inline) { ;
__p += '\n    <button type="button" class="btn js-cancel-popup">' +
((__t = ( _.i18n('common.close', null, 'Close') )) == null ? '' : __t) +
'</button>\n    ';
 } ;
__p += '\n    <button type="button" class="btn btn-primary js-send">' +
((__t = ( _.i18n('portalMessages.send', null, 'Send to supplier') )) == null ? '' : __t) +
'</button>\n  </div>\n</div>\n';

}
return __p
};});

